import React from "react";
import { OptiCommonHeader } from "../../components/OptiCommonHeader/OptiCommonHeader";
import { Unauthorized } from "./Unauthorized";

export const UnauthorizedWithGlobalBar = () => {
    return (
        <>
            <OptiCommonHeader />
            <Unauthorized />
        </>
    );
};

UnauthorizedWithGlobalBar.displayName = "Unauthorized with global bar";
